export default "__VITE_ASSET__gNgmXuCy__"